package org.example.zone360.pages.coachDetails

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.models.ToastPlacement
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaGear
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getClubWidgets
import org.example.zone360.utils.getCoachWidgetProfile
import org.example.zone360.utils.getPlayerAggregate
import org.example.zone360.utils.getSingleCoach
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.components.BSToastBasicCustom
import org.example.zone360.components.BSToastGroupCustom
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.GetClubWidgetPayload
import org.example.zone360.components.SaveWidgetPayload
import org.example.zone360.components.WidgetSelectionPopup
import org.example.zone360.components.WidgetSelectionValidationPopup
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.rememberWidgetRenderers
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.CoachWidgetResponse
import org.example.zone360.models.DashboardChatState
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.models.GetWidgetCoachProfilePayload
import org.example.zone360.pages.coachDetails.coachAssistAi.CoachAnnualSubscriptions
import org.example.zone360.pages.coachDetails.coachAssistAi.CoachAssistAI
import org.example.zone360.pages.coachDetails.coachAssistAi.CoachAssistAIOverlay
import org.example.zone360.pages.coachDetails.coachInfo.CoachInfo
import org.example.zone360.pages.coachDetails.coachPlayerList.CoachPlayerList
import org.example.zone360.pages.coachDetails.coachSession.CoachesSession
import org.example.zone360.pages.coachDetails.sessionAllDetails.SessionAllDetails
import org.example.zone360.pages.dashboard.paymentPopup.ClubCoachPaymentPopup
import org.example.zone360.sections.DashboardHeaderSection
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.mediaManagerUtils.AudioManager
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.mediaManagerUtils.VideoManager
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.injectChatAnimationStyles
import org.example.zone360.utils.injectMarkdownStyles
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.example.zone360.utils.saveWidgetConfig
import kotlin.coroutines.cancellation.CancellationException

@Page("/coach-details")
@Composable
fun CoachDetails() {
    val ctx = rememberPageContext()
    if (ctx.isExporting) return

    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var message by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
    var isPlayersLoading by remember { mutableStateOf(true) }
    var isChatOpen by remember { mutableStateOf(false) }
    val chatState = remember {
        DashboardChatState()
    }

//
    val userId = ctx.route.params["userId"]
    var disable by remember { mutableStateOf(true) }
    var isWidgetLoading by remember { mutableStateOf(false) }

    if (userId.isNullOrBlank() || (AppGlobal.userData.payment.checkout.status != Strings.PAID && AppGlobal.userData.role == Strings.ADMIN)) {
        LaunchedEffect(Unit) {
            ctx.router.navigateTo("/home")
        }
        return
    }
    val sessionId = ctx.route.params["sessionId"]
    val category = ctx.route.params["category"]


    var selectedDataType by remember {
        mutableStateOf(SelectedData.Training)
    }
    LaunchedEffect(Unit) {
        injectMarkdownStyles()
        injectChatAnimationStyles()
    }

    // AFTER
    LaunchedEffect(category) {
        selectedDataType = when {
            category == "request_match" ->
                SelectedData.Matches

            category == "request_training" ->
                SelectedData.Training

            !category.isNullOrBlank() &&
                    localStorage.getItem("selectedDataType") == Strings.MATCH ->
                SelectedData.Matches
            // ✅ Add this: read dashboard's saved selection when no category param
            category.isNullOrBlank() &&
                    localStorage.getItem("selectedDataType") == Strings.MATCH ->
                SelectedData.Matches

            else ->
                SelectedData.Training
        }
    }

    var selectedLanguage by remember {
        mutableStateOf(
            when (localStorage.getItem("selectedLanguage")) {
                "it" -> SelectedLanguage.Italian
                else -> SelectedLanguage.English
            }
        )
    }
    var showOverlay by remember { mutableStateOf(false) }

    val hasValidOrganization = AppGlobal.userData.organization != Strings.INDEPENDENT

    if (AppGlobal.userData.role == Strings.PLAYER) {
        ctx.router.navigateTo("/player-details")
        return
    }
    val data = localStorage.getItem("userData")
    if (data == null) {
        ctx.router.navigateTo("/login")
        return
    }

    var selectedSession by remember { mutableStateOf(GetSessionsData()) }
    var updatedSession by remember { mutableStateOf<GetSessionsData?>(null) }
    var selectedTeam by remember { mutableStateOf<List<String>>(emptyList()) }
    var coachProfile by remember { mutableStateOf<GetSingleCoachData?>(null) }
    var allSessions by remember { mutableStateOf<List<GetSessionsData>>(emptyList()) }
    var isClubExpired by remember { mutableStateOf(false) }
    var subscriptionPopup by remember { mutableStateOf(false) }
    var coachPlayerList by remember { mutableStateOf(emptyList<GetPlayerData>()) }
    var infoApiCalled by remember { mutableStateOf(false) }
    var clubWidgetResponse by remember { mutableStateOf<CoachWidgetResponse?>(null) }

    val defaultWidgetIds = setOf(1, 2, 3, 4)
    var selectedWidgetIds by remember { mutableStateOf(defaultWidgetIds) }
    var tempSelectedWidgetIds by remember { mutableStateOf(defaultWidgetIds) }
    var showWidgetValidationPopup by remember { mutableStateOf(false) }
    var showWidgetPopup by remember { mutableStateOf(false) }
    var isDashboardExpanded by remember { mutableStateOf(AppGlobal.isCoachChatbotExpanded) }

    // Save to AppGlobal when changed
    LaunchedEffect(isDashboardExpanded) {
        AppGlobal.isCoachChatbotExpanded = isDashboardExpanded
    }

    val dashboardWidgetRenderers = rememberWidgetRenderers(
        widgetData = clubWidgetResponse?.averages,
        recentTrend = clubWidgetResponse?.recentTrend,
        showSelection = false,
        isCoachPage = true,
        selectedIds = selectedWidgetIds
    ) { _, _ -> }

    val popupWidgetRenderers = rememberWidgetRenderers(
        widgetData = clubWidgetResponse?.averages,
        recentTrend = clubWidgetResponse?.recentTrend,
        showSelection = true,
        isCoachPage = true,
        selectedIds = tempSelectedWidgetIds
    ) { id, checked ->

        tempSelectedWidgetIds =
            if (checked)
                tempSelectedWidgetIds + id
            else
                tempSelectedWidgetIds - id
    }

    if (showWidgetValidationPopup) {
        WidgetSelectionValidationPopup(
            currentCount = tempSelectedWidgetIds.size,
            onChooseMore = {
                // Close validation popup, keep selection popup open
                showWidgetValidationPopup = false
            },
            onKeepFour = {
                // Trim to 4 and save
                val trimmedToFour = tempSelectedWidgetIds.sorted().take(4).toSet()
                tempSelectedWidgetIds = trimmedToFour
                selectedWidgetIds = trimmedToFour
                showWidgetValidationPopup = false
            }
        )
    }
    val widgetKeyMap = mapOf(
        1 to "coach_talk_ratio",
        2 to "session_intensity",
        3 to "game_realism",
        4 to "development_orientation",
        5 to "tactical_complexity",
        6 to "topic_diversity",
        7 to "methodology_consistency",
        8 to "cognitive_training",
        9 to "competitive_environment",
        10 to "match_analysis"
    )

    val widgetIdMap = widgetKeyMap.entries.associate { (id, key) ->
        key to id
    }

    LaunchedEffect(userId, AppGlobal.selectedSeasonId) {
        if (userId.isBlank()) return@LaunchedEffect
        try {
            isWidgetLoading = true

            val widgetResponse = getClubWidgets(
                GetClubWidgetPayload(
                    organization = AppGlobal.userData.organization,
                    userId = userId
                )
            )

            selectedWidgetIds = if (widgetResponse.selectedWidgets.isEmpty()) {
                defaultWidgetIds
            } else {
                widgetResponse.selectedWidgets
                    .mapNotNull { widgetIdMap[it] }
                    .toSet()
                    .ifEmpty { defaultWidgetIds }
            }

        } catch (ce: CancellationException) {
            throw ce
        } catch (e: Exception) {
            selectedWidgetIds = defaultWidgetIds
            debugPrintln("Coach Widget Error: ${e.message}")
        } finally {
            isWidgetLoading = false
        }
    }
    if (subscriptionPopup) {
        CoachAnnualSubscriptions(
            onDialogDismiss = { subscriptionPopup = false },
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            getCoachInfo = coachProfile ?: GetSingleCoachData(),
            toastMessage = { message = it }
        )
    }
    if (isClubExpired) {
        ClubCoachPaymentPopup(
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            ctx = ctx,
            logoutRow = false,
            onDialogClose = {
                isClubExpired = false
            }
        )
    }

    LaunchedEffect(Unit) {
        if (AppGlobal.selectedSeasonId.isEmpty()) {
            AppGlobal.selectedSeasonId =
                localStorage.getItem("selectedSeasonId") ?: ""

            AppGlobal.selectedSeason =
                localStorage.getItem("selectedSeason") ?: ""
        }
    }
    DisposableEffect(Unit) {
        onDispose {
            AudioManager.releaseAll()
            VideoManager.releaseAll()
        }
    }
    LaunchedEffect(AppGlobal.refreshCoachProfile) {
        try {
            isPlayersLoading = true
            val res = getSingleCoach(
                organization = AppGlobal.userData.organization,
                domainType = "soccer",
                language = "en",
                sessionType = selectedDataType.name,
                userID = userId,
                seasonID = AppGlobal.selectedSeasonId
            )
            coachProfile = res.data
            disable = res.data.disabled
        } catch (ce: CancellationException) {
            throw ce
        } catch (e: Exception) {
            debugPrintln("Error fetching coach data: $e")
        } finally {
            isPlayersLoading = false

        }
    }

    LaunchedEffect(userId, AppGlobal.selectedSeasonId) {
        if (userId.isBlank()) return@LaunchedEffect
        try {
            val widgetResponse = getCoachWidgetProfile(
                GetWidgetCoachProfilePayload(
                    userId = userId,
                    organization = AppGlobal.userData.organization,
                    seasonId = AppGlobal.selectedSeasonId
                )
            )

            clubWidgetResponse = widgetResponse

        } catch (e: CancellationException) {
            throw e
        } catch (e: Exception) {
            debugPrintln("Coach Widget Error: ${e.message}")
        }
    }


    LaunchedEffect(selectedTeam, infoApiCalled) {
        if (!infoApiCalled) {
            return@LaunchedEffect
        }
        try {
            isLoading = true
            val playerData = getPlayerAggregate(
                organization = AppGlobal.userData.organization,
                domainType = "soccer",
                language = "en",
                team = selectedTeam,
                teamOnly = true,
                seasonID = AppGlobal.selectedSeasonId
            )
            coachPlayerList = playerData.data.toList()
        } catch (e: Exception) {
            debugPrintln(" Error fetching player data: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    Box(Modifier.fillMaxSize()) {
        Column(
            Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackground.rgb)
                .overflow(overflowX = Overflow.Hidden, overflowY = Overflow.Auto)
                .id(Res.Id.coachesPage)
        ) {

            BSToastGroupCustom(
                placement = ToastPlacement.TopRight,
            ) {
                BSToastBasicCustom(
                    id = "toastSuccess",
                    text = message,
                    style = ToastStyle.Success,
                    autoHide = true,
                    closeButtonDark = false,
                    onCloseClick = {}
                )
                BSToastBasicCustom(
                    id = "toastError",
                    text = message,
                    style = ToastStyle.Danger,
                    autoHide = true,
                    closeButtonDark = false,
                    onCloseClick = {}
                )
            }

            DashboardHeaderSection(
                toastMessage = { message = it },
                clubButton = AppGlobal.userData.organization != Strings.INDEPENDENT
            )
            Column(
                modifier = Modifier.fillMaxHeight()
                    .fillMaxWidth(if (window.screen.width > 1900) 1800.px else 100.percent)
                    .padding(leftRight = if (breakpoint >= Breakpoint.LG) 60.px else 20.px)
                    .align(Alignment.CenterHorizontally),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().margin(top = 30.px, bottom = 10.px),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    if (hasValidOrganization) {
                        FaArrowLeft(
                            modifier = Modifier
                                .onClick {
                                    if (window.history.length > 1) {
                                        window.history.back()
                                    } else {
                                        ctx.router.navigateTo("/home")
                                    }
                                }
                                .cursor(Cursor.Pointer)
                        )
                    }

                    FieldTitleTextNormalSimple(
                        text = "Coach Details",
                        fontWeight = 500,
                        fontSize = 16.px,
                        marginLeft = if (AppGlobal.userData.organization.isEmpty() ||
                            AppGlobal.userData.organization.equals("null", ignoreCase = true)
                        ) 0.px
                        else 15.px
                    )
                    Spacer()
                    Box(
                        modifier = Modifier
                            .borderRadius(6.px)
                            .border(1.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                            .padding(leftRight = 12.px, topBottom = 6.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                tempSelectedWidgetIds = selectedWidgetIds
                                showWidgetPopup = true
                            }

                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            FaGear(modifier = Modifier.margin(right = 6.px), size = IconSize.SM)
                            FieldTitleTextNormalSimple(
                                "Manage Widgets",
                                fontSize = 14.px,
                                fontWeight = 500,
                                isClickable = true
                            )
                        }
                    }
                }
                CoachInfo(
                    breakpoint = breakpoint,
                    sitePalette = sitePalette,
                    userId = userId,
                    selectedSession = selectedDataType,
                    message = { message = it },
                    team = {
                        selectedTeam = it
                        infoApiCalled = true
                    },
                    coachData = {
                        coachProfile = it
                    },
                    showInfoOverlay = {
                    },
                    getCoachInfo = coachProfile ?: GetSingleCoachData(),
                    isLoading = isLoading,
                    disable = disable
                )
//                Row(modifier = Modifier.fillMaxWidth().margin(top = 10.px)) {
//                    Spacer()
//                    CommonButton(
//                        text = "Add New Widgets",
//                        icon = {
//                            FaPlus(
//                                size = IconSize.X1,
//                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb)
//                            )
//                        },
//                        width = 150.px,
//                        height = 40.px,
//                        onCLick = {
//                            tempSelectedWidgetIds = selectedWidgetIds
//                            showWidgetPopup = true
//                        })
//                }
                val sortedSelectedIds = selectedWidgetIds.sorted()
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .flexWrap(FlexWrap.Wrap)
                        .gap(12.px)
                        .margin(topBottom = 10.px),
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.Top
                ) {
                    sortedSelectedIds.forEachIndexed { index, id ->
                        dashboardWidgetRenderers[id]?.invoke(index + 1)  // ✅ Pass 1,2,3,4...
                    }
                }
                if (showWidgetPopup) {
                    WidgetSelectionPopup(
                        selectedIds = tempSelectedWidgetIds,
                        isLoading = isWidgetLoading,
                        onClose = {
                            showWidgetPopup = false
                        },
                        onSave = {
                            val count = tempSelectedWidgetIds.size
                            when {
                                count in 0..3 -> {
                                    // Show validation popup
                                    showWidgetValidationPopup = true
                                }

                                count in 5..7 -> {
                                    // Show validation popup
                                    showWidgetValidationPopup = true
                                }

                                count > 8 -> {
                                    // Show validation popup
                                    showWidgetValidationPopup = true
                                }

                                else -> {
                                    // Valid: count is 4 or 8
                                    scope.launch {
                                        try {
                                            isWidgetLoading = true

                                            val selectedWidgets = tempSelectedWidgetIds
                                                .sorted()
                                                .mapNotNull { widgetKeyMap[it] }

                                            val response = saveWidgetConfig(
                                                SaveWidgetPayload(
                                                    organization = AppGlobal.userData.organization,
                                                    userId = userId,
                                                    selectedWidgets = selectedWidgets
                                                )
                                            )

                                            selectedWidgetIds = tempSelectedWidgetIds
                                            showWidgetPopup = false

                                            message = "Widgets saved successfully"
                                            showToast(ToastID.SUCCESS)

                                            debugPrintln("Widget saved: ${response.data}")

                                        } catch (e: Exception) {
                                            message = e.message ?: "Failed to save widgets"
                                            showToast(ToastID.ERROR)
                                        } finally {
                                            isWidgetLoading = false
                                        }
                                    }
//                                    selectedWidgetIds = tempSelectedWidgetIds
//                                    localStorage.setItem(
//                                        "selectedWidgetIds",
//                                        tempSelectedWidgetIds.sorted().joinToString(",")
//                                    )
//                                    showWidgetPopup = false
                                }
                            }
                        }
                    ) {
                        // Widget selection is available on ALL screens
                        val allWidgetIds = (1..10).toList()
                        if (window.screen.width > 1440) {
                            // Above 1440px: Split into chunks of 5 (2 rows of 5)
                            allWidgetIds.chunked(5).forEachIndexed { index, chunk ->
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .flexWrap(FlexWrap.Wrap)
                                        .gap(12.px)
                                        .margin(bottom = if (index == 0) 12.px else 0.px)
                                ) {
                                    chunk.forEach { id ->
                                        popupWidgetRenderers[id]?.invoke(id)
                                    }
                                }
                            }
                        } else {
                            // Below 1440px: Show all 10 widgets in a single row (or wrapped)
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .flexWrap(FlexWrap.Wrap)
                                    .gap(12.px)
                            ) {
                                allWidgetIds.forEach { id ->
                                    popupWidgetRenderers[id]?.invoke(id)
                                }
                            }
                        }
                    }
                }


                if (hasValidOrganization) {
                    CoachPlayerList(
                        breakpoint,
                        sitePalette,
                        selectedTeam = selectedTeam,
                        message = { message = it },
                        isLoading = isPlayersLoading,
                        coachPlayerList = coachPlayerList,
                        onPlayerAdded = { newPlayersList ->
                            coachPlayerList = newPlayersList
                        },
                        disable = disable
                    )
                }
                CoachAssistAI(
                    onDismiss = { isChatOpen = false },
                    breakpoint = breakpoint,
                    sitePalette = sitePalette,
                    toastMessage = { message = it },
                    userId = userId,
                    getCoachInfo = coachProfile ?: GetSingleCoachData(),
                    selectedSessionType = selectedDataType,
                    selectedLanguage = selectedLanguage,
                    sessionList = allSessions,
                    showOverlay = showOverlay,
                    onShowOverlayChange = { showOverlay = it },
                    subscriptionPopup = { subscriptionPopup = it },
                    playersList = coachPlayerList,
                    // ⭐ NEW — wires the fullscreen popup + in-place expand
                    isChatOpen = false,                                  // inline copy never renders "open"; the overlay below handles that
                    onExpandToggle = {
                        isChatOpen = true
                    },               // clicking the expand-arrow opens the fullscreen overlay
                    isDashboardExpanded = isDashboardExpanded,
                    onDashboardExpandToggle = {
                        isDashboardExpanded = !isDashboardExpanded
                        AppGlobal.isCoachChatbotExpanded = !isDashboardExpanded
                    },
                    scrollContainerId = Res.Id.coachDashboardBot,
                    messageInputId = Res.Id.coachMessageInput,
                    chatMessages = chatState
                )

                Row(
                    modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px)
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column(
                        Modifier.width(
                            if (breakpoint > Breakpoint.LG) 29.percent
                            else if (breakpoint >= Breakpoint.LG) 31.percent
                            else if (breakpoint > Breakpoint.MD) 49.percent
                            else 100.percent
                        )
                    ) {
                        CoachesSession(
                            breakpoint = breakpoint,
                            sitePalette = sitePalette,
                            userId = userId,
                            notificationSessionId = sessionId ?: "",
                            notificationCategory = category ?: "",
                            updatedSession = updatedSession,
                            sessionDataType = selectedDataType,
                            onSessionTypeChange = { newType ->
                                selectedDataType = newType
                            },
                            onSessionSelect = { session ->
                                selectedSession = session
                            },
                            onSessionListFetched = {
                                allSessions = it
                            },
                            getCoachInfo = coachProfile ?: GetSingleCoachData(),
                            toastMessageCall = { message = it },
                            subscriptionPopup = {
                                subscriptionPopup = it
                            },
                            clubExpiryPopup = {
                                isClubExpired = it
                            },
                            disable = disable
                        )
                        CustomSpacer(height = if (breakpoint > Breakpoint.LG) 30.px else 10.px)

                    }
                    SessionAllDetails(
                        breakpoint = breakpoint,
                        sitePalette = sitePalette,
                        sessionType = selectedDataType,
                        sessionData1 = selectedSession,
                        videoUrlFile = {
                            updatedSession = it
                        },
                        message = { message = it },
                        selectedTeam = selectedTeam,
                        selectedWidgetIds = selectedWidgetIds,
                        userId = userId,
                        updateCoachInfo = {
                            coachProfile = it
                        },
                        disable = disable,
                        teamIds = selectedTeam
                    )

                }

            }

        }
        CoachAssistAIOverlay(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            isChatOpen = isChatOpen,
            onDismiss = { isChatOpen = false },
            userId = userId,
            coachProfile = coachProfile,
            selectedDataType = selectedDataType,
            selectedLanguage = selectedLanguage,
            allSessions = allSessions,
            showOverlay = showOverlay,
            onShowOverlayChange = { showOverlay = it },
            subscriptionPopup = { subscriptionPopup = it },
            coachPlayerList = coachPlayerList,
            chatMessages = chatState
        )

    }
}
